import { FC, useCallback } from "react";
import { useTableContext } from "./context";

export const TablePagerInfo: FC = () => {
  const { table } = useTableContext();

  if (!table) {
    throw new Error("table undefined");
  }

  const { pageCount, setPageSize, page, state: { pageSize, pageIndex } } = table;

  const total = pageCount * pageSize;
  const de = Math.min(1 + (pageSize * pageIndex), total);
  const ate = Math.max(de + page.length - 1, 0);

  const handlePageSizeChange = useCallback((e) => {
    setPageSize(Number(e.target.value));
  }, [setPageSize]);

  return (
    <div className="btn-group d-flex justify-content-center align-items-center">
      <select
        value={pageSize}
        onChange={handlePageSizeChange}
        className="form-select form-select-sm mx-3"
        style={{ width: "72px" }}>
        {[5, 10, 20, 50, 100, 200].map((pageSize) => (
          <option key={pageSize} value={pageSize}>{pageSize}</option>
        ))}
      </select>
      <div style={{ minWidth: "200px" }}>
        Mostrando {de} - {ate}
      </div>
    </div>
  );
};
